import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {ConfigurationService} from '../../../../../configuration/configuration.service';
import {ConfigurationModel, FeatureFlagEnum} from '../../../../../shared/models/configuration.model';
import {ImportVehiclesComponent} from '../import-vehicles.component';
import {ImportVehiclesCartegraphComponent} from '../vehicle-import-cartegraph/import-vehicles-cartegraph.component';
import {AddOrImportVehicleDialogForm, EditVehicleComponentInputData} from '../model/vehicle.types';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-import-vehicles-dialog',
  templateUrl: './import-vehicles-dialog.component.html',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatProgressBar,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    ImportVehiclesComponent,
    ImportVehiclesCartegraphComponent
  ]
})
export class ImportVehiclesDialogComponent implements OnInit, OnDestroy {

  private configurationSubscription: Subscription;
  private isInitialized = false;
  isWorking = false;
  saveError?: string;

  /**
   * A nullable flag telling whether the current account has the `FeatureFlagEnum.CartegraphIntegration`
   * feature flag.
   * It is set to `null` when the flag presence is unknown.
   * It is set to `true` if the flag is present.
   * It is set to `false` when the flag is missing.
   */
  cartegraphEnabled: boolean = null;

  activeVehicleEntryComponent: ActiveComponent = ActiveComponent.NONE;
  @ViewChild('importVehiclesComponent') importVehiclesComponent: ImportVehiclesComponent;
  @ViewChild('importVehiclesCartegraphComponent') importVehiclesCartegraphComponent: ImportVehiclesCartegraphComponent;

  constructor(
    private readonly dialogRef: MatDialogRef<ImportVehiclesDialogComponent>,
    private readonly configurationService: ConfigurationService,
    @Inject(MAT_DIALOG_DATA) protected data: EditVehicleComponentInputData,
  ) {
    // dialogRef.addPanelClass('use-material-design-3-theme');
  }

  ngOnInit() {
    this.configurationSubscription = this.configurationService.sharedConfigurationModel.subscribe(cfg => {
      if (cfg) {
        this.handleConfigurationLoaded(cfg);
      }
    });
    this.initAsync();
  }

  ngOnDestroy() {
    this.configurationSubscription?.unsubscribe();
  }

  protected isSaveButtonEnabled() {
    const formComponent = this.resolveActiveFormComponent();
    return this.isInitialized && !this.isWorking && !!formComponent && formComponent.canBeSaved();
  }

  protected performSave() {
    delete this.saveError;
    const formComponent = this.resolveActiveFormComponent();
    if (!formComponent) {
      throw new Error('Cannot import while there is not active user entry component.');
    }

    this.isWorking = true;
    const disableCloseStateToRestore = this.dialogRef.disableClose;
    this.dialogRef.disableClose = true;

    formComponent.save()
      .then((vehicleResult) => {
        this.dialogRef.close(vehicleResult);
      })
      .catch((saveError) => {
        this.saveError = saveError;
        console.warn('vehicle save error', saveError);
        // this.editVehicleComponent.showSaveErrorToast();
      })
      .finally(() => {
        this.isWorking = false;
        this.dialogRef.disableClose = disableCloseStateToRestore;
      });

  }

  private resolveActiveFormComponent(): AddOrImportVehicleDialogForm {
    switch (this.activeVehicleEntryComponent) {
      case ActiveComponent.NONE:
        return null;
      case ActiveComponent.IMPORT_VEHICLES:
        return this.importVehiclesComponent;
      case ActiveComponent.IMPORT_FROM_CARTEGRAPH:
        return this.importVehiclesCartegraphComponent;
      default:
        throw new Error('Unknown vehicle entry component.');
    }
  }

  private handleConfigurationLoaded(cfg: ConfigurationModel) {
    this.cartegraphEnabled = cfg.hasFeatureFlag(FeatureFlagEnum.CartegraphIntegration);

    if (this.cartegraphEnabled) {
      this.activeVehicleEntryComponent = ActiveComponent.IMPORT_FROM_CARTEGRAPH;
    } else {
      this.activeVehicleEntryComponent = ActiveComponent.IMPORT_VEHICLES; // the tab at index 0
    }
  }

  private initAsync() {
    // FIXME: Find a proper solution to avoid ExpressionChangedAfterItHasBeenCheckedError. See https://angular.io/errors/NG0100
    setTimeout(() => {
      this.isInitialized = true;
    }, 0);
  }
}

enum ActiveComponent {
  NONE,
  IMPORT_VEHICLES,
  IMPORT_FROM_CARTEGRAPH,
}
